import { render, staticRenderFns } from "./SlrcExL.vue?vue&type=template&id=d6066712"
import script from "./SlrcExL.vue?vue&type=script&lang=js"
export * from "./SlrcExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports